var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible",
        },
      ],
      staticClass: "e_mask",
      style: { "z-index": _vm.zIndex },
      on: { click: _vm.closeMenu },
    },
    [
      _c("div", {
        ref: "contextmenu",
        staticClass: "contextmenu",
        style: { left: _vm.left + "px", top: _vm.getTop(_vm.top) },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }